"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "shield"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.7074 0.886403C9.89605 0.815657 10.1039 0.815657 10.2926 0.886403L16.9593 3.3864C17.2845 3.50837 17.5 3.81931 17.5 4.16668V10C17.5 12.872 15.5985 15.1669 13.8821 16.6688C13.0064 17.4351 12.1345 18.034 11.4833 18.441C11.1569 18.6451 10.8836 18.8023 10.6901 18.9094C10.5932 18.963 10.5162 19.0042 10.4622 19.0325C10.4352 19.0467 10.414 19.0576 10.399 19.0654L10.381 19.0745L10.3756 19.0772L10.3739 19.0781C10.3736 19.0782 10.3727 19.0787 10 18.3333C9.62732 19.0787 9.62708 19.0786 9.62681 19.0784L9.62435 19.0772L9.61895 19.0745L9.60104 19.0654C9.58598 19.0576 9.56475 19.0467 9.53777 19.0325C9.48381 19.0042 9.40677 18.963 9.30995 18.9094C9.1164 18.8023 8.84314 18.6451 8.51667 18.441C7.86545 18.034 6.99365 17.4351 6.11791 16.6688C4.40146 15.1669 2.5 12.872 2.5 10V4.16668C2.5 3.81931 2.71548 3.50837 3.04073 3.3864L9.7074 0.886403ZM10 18.3333L9.62681 19.0784C9.86141 19.1957 10.1381 19.196 10.3727 19.0787L10 18.3333ZM10 17.3856C10.1597 17.2951 10.3639 17.1753 10.6 17.0277C11.1988 16.6535 11.9936 16.1066 12.7846 15.4145C14.4015 13.9998 15.8333 12.128 15.8333 10V4.74418L10 2.55668L4.16667 4.74418V10C4.16667 12.128 5.59855 13.9998 7.21542 15.4145C8.00635 16.1066 8.80121 16.6535 9.4 17.0277C9.63608 17.1753 9.8403 17.2951 10 17.3856Z",
    fill: fill
  })));
};

exports["default"] = _default;